import React from 'react'
import './Footer.css'
import {FaFacebook, FaLinkedin, FaTwitter, FaMailBulk, FaPhone, FaSearchLocation} from 'react-icons/fa'

const Footer = () => {
  return (
    <div className='footer'>
        <div className='footer-container'>
            <div className='left'>
                <div className='location'>
                    <FaSearchLocation size={20} style={{color: '#F3FFC6', marginRight: '2rem'}} />
                    <div>
                        <p>Gauteng, South Africa</p>
                    </div>
                </div>
                <div className='phone'>
                    <h4><FaPhone size={20} style={{color: '#F3FFC6', marginRight: '2rem'}} /> 081 443 1889/069 389 2785
                    </h4>
                </div>
                <div className='email'>
                    <h4><FaMailBulk size={20} style={{color: '#F3FFC6', marginRight: '2rem'}} /> info@bio-zeit.com
                    </h4>
                </div>
            </div>
            <div className='right'>
                <div className='social'>
                    <FaFacebook size={30} style={{color: '#F3FFC6', marginRight: '2rem'}} />
                    <FaLinkedin size={30} style={{color: '#F3FFC6', marginRight: '2rem'}} />
                    <FaTwitter size={30} style={{color: '#F3FFC6', marginRight: '2rem'}} />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer